import axios from '@/lib/axios';

const checkAccessContact = (token: string) => {
  return axios.get('/facility/contact/' + token);
}

export default checkAccessContact;